import request from "../../utils/request";

export function signIn(params) {
  return request("/auth/login", {
    method: "POST",
    data: params,
  });
}

export function signUp(params) {
  return request("/auth/register", {
    method: "POST",
    data: params,
  });
}

export function forgotPassword(params) {
  return request("/auth/reset-password", {
    method: "POST",
    data: params,
  });
}

export function resetPassword(params) {
  return request("/auth/confirm-reset", {
    method: "POST",
    data: params,
  });
}
